import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import vModel from '@/app-core/mixins/vModel'

export default {
  name      : 'OtpDialog',
  components: {},
  directives: {},
  mixins    : [DialogVisible, vModel],
  props     : {
    otpProgress: {
      type   : Object,
      default: undefined
    },
    otpError: {
      type   : String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onOtpValidate() {
      this.$emit('validate')
    }
  }
}
